// extracted by mini-css-extract-plugin
export var actionButton = "_fj-0";
export var fileInput = "_fj-2";
export var paperclip = "_fj-1";